export default "__VITE_ASSET__rZ1SToPj__";